import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../../../../Helper/Toast";
import { hitUpdateNotificationSettingProfessionalApi } from "../../../../../Redux/Professional/UpdateNotificationSettingProfessionalSlice";
import { hitGetProfileApi } from "../../../../../Redux/Professional/GetProfileSlice";

const Notification = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const [preferences, setPreferences] = useState({});

  useEffect(() => {
    if (!localStorage.getItem("professionalToken")) {
      navigation("/professional/login");
    } else {
      dispatch(hitGetProfileApi()).then((response) => {
        if (response.payload && response.payload.status === true) {
          setPreferences({
            emailNotificationOnOff:
              response.payload.data.emailNotificationOnOff === 1 ? true : false,
            smsNotificationOnOff:
              response.payload.data.smsNotificationOnOff === 1 ? true : false,
            notificationOnOff:
              response.payload.data.notificationOnOff === 1 ? true : false,
            marketingNotificationOnOff:
              response.payload.data.marketingNotificationOnOff === 1
                ? true
                : false,
          });
        }
      });
    }
  }, []);

  const handleToggle = (key) => {
    setPreferences({
      ...preferences,
      [key]: !preferences[key],
    });
  };

  const handleSave = () => {
    //console.log("Saving preferences:", preferences);
    const converted = Object.fromEntries(
      Object.entries(preferences).map(([key, value]) => [key, value ? 1 : 0])
    );
    dispatch(hitUpdateNotificationSettingProfessionalApi(converted))
      .then((response) => {
        if (response.payload && response.payload.status === true) {
          showToast("Notifications settings updated successfully", "success");
          dispatch(hitGetProfileApi()).then((response) => {
            if (response.payload && response.payload.status === true) {
              setPreferences({
                emailNotificationOnOff:
                  response.payload.data.emailNotificationOnOff === 1
                    ? true
                    : false,
                smsNotificationOnOff:
                  response.payload.data.smsNotificationOnOff === 1
                    ? true
                    : false,
                notificationOnOff:
                  response.payload.data.notificationOnOff === 1 ? true : false,
                marketingNotificationOnOff:
                  response.payload.data.marketingNotificationOnOff === 1
                    ? true
                    : false,
              });
            }
          });
        }
      })
      .catch((error) => {
        showToast("Notifications settings update failed", "error");
      });
  };

  const notificationSettings = [
    {
      key: "emailNotificationOnOff",
      title: "Email Notifications",
      description: "Receive updates about your projects via email",
      enabled: preferences.emailNotificationOnOff,
    },
    {
      key: "smsNotificationOnOff",
      title: "SMS Notifications",
      description: "Get text messages for urgent updates",
      enabled: preferences.smsNotificationOnOff,
    },
    {
      key: "notificationOnOff",
      title: "Push Notifications",
      description: "Receive notifications in the mobile app",
      enabled: preferences.notificationOnOff,
    },
    {
      key: "marketingNotificationOnOff",
      title: "Marketing Communications",
      description: "Receive tips and updates about home renovation",
      enabled: preferences.marketingNotificationOnOff,
    },
  ];

  return (
      <div className="notification-preferences-container">
        <div className="preferences-data">
          <div className="preferences-list">
            {notificationSettings.map((setting) => (
              <div key={setting.key} className="preference-item">
                <div className="preference-info">
                  <h3 className="preference-title">{setting.title}</h3>
                  <p className="preference-description">
                    {setting.description}
                  </p>
                </div>

                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    className="toggle-input"
                    checked={setting.enabled}
                    onChange={() => handleToggle(setting.key)}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>
            ))}
          </div>

          <button className="save-button" onClick={handleSave}>
            Save Preferences
          </button>
        </div>
      </div>
  );
};

export default Notification;
